module.exports = __WEBPACK_EXTERNAL_MODULE_15__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"@darkobits/interface","commonjs2":"@darkobits/interface","amd":"@darkobits/interface","root":"Interface"}
// module id = 15
// module chunks = 0